/**
 * CRM no novo desenho, lote 4 (complemento 2 do clone do RD): o desconto do produto da negociação com a escolha visível entre
 * "% Porcentagem" e "R$ Valor". Trocar converte o número digitado; a equivalência aparece ao lado ("10% = R$ 40,00"); limites:
 * até 100% e até o valor x quantidade. Regras puras, testadas em `apps/web/tests/crm-l4-ficha.test.ts`; o servidor confere o
 * mesmo (`validarItens`).
 */
export type TipoDesconto = 'percentual' | 'valor';

/** Bruto do item em centavos (quantidade x preço, arredondado). */
export const bruto = (quantidade: number, precoCentavos: number) => Math.round(quantidade * precoCentavos);

/** Desconto em centavos a partir do que foi digitado (percentual ou reais). */
export function descontoEmCentavos(tipo: TipoDesconto, digitado: number, quantidade: number, precoCentavos: number): number {
  if (!(digitado > 0)) return 0;
  return tipo === 'percentual' ? Math.round((bruto(quantidade, precoCentavos) * digitado) / 100) : Math.round(digitado * 100);
}

/** Converte o número digitado ao trocar o tipo: 10 (%) de R$ 400 vira 40 (R$); 40 (R$) vira 10 (%). Duas casas. */
export function converterDesconto(de: TipoDesconto, para: TipoDesconto, digitado: number, quantidade: number, precoCentavos: number): number {
  if (de === para || !(digitado > 0)) return de === para ? digitado : 0;
  const total = bruto(quantidade, precoCentavos);
  if (para === 'valor') return Math.round(total * digitado) / 10000;
  return total ? Math.round(((digitado * 100) / total) * 10000) / 100 : 0;
}

/** Erro do limite (chave i18n e o máximo), ou null quando cabe. */
export function erroDoDesconto(tipo: TipoDesconto, digitado: number, quantidade: number, precoCentavos: number): { chave: 'negativo' | 'percentualMaximo' | 'valorMaximo'; maximo: number } | null {
  if (digitado < 0) return { chave: 'negativo', maximo: 0 };
  if (tipo === 'percentual' && digitado > 100) return { chave: 'percentualMaximo', maximo: 100 };
  const total = bruto(quantidade, precoCentavos);
  if (tipo === 'valor' && Math.round(digitado * 100) > total) return { chave: 'valorMaximo', maximo: total };
  return null;
}

/** Percentual que o desconto representa do bruto (duas casas), para a equivalência "R$ 40,00 = 10% do valor". */
export const percentualDoDesconto = (descontoCentavos: number, quantidade: number, precoCentavos: number) => {
  const total = bruto(quantidade, precoCentavos);
  return total ? Math.round((descontoCentavos / total) * 10000) / 100 : 0;
};
